import { useEffect } from 'react'
import getScrollBarWidth from 'common/helpers/getters/getScrollBarWidth'


const useBodyOverlay = (isOpened) => {
  useEffect(() => {
    if (isOpened) {
      document.body.classList.add('body-overlay')
      document.body.style.paddingRight = `${getScrollBarWidth()}px`
    }
    else {
      document.body.classList.remove('body-overlay')
      document.body.style.paddingRight = '0px'
    }


    return () => {
      document.body.classList.remove('body-overlay')
      document.body.style.paddingRight = '0px'
    }
  }, [ isOpened ])
}


export default useBodyOverlay
